import apiClient from '@/services/axios'

export async function put(venue) {
  var venueId = venue.id;

  var response = await apiClient.put(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-details/' + venueId, venue);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get Team Members.')
}
